import StorageService from '../session/storage.service';
import AppSetting from '../../common/constants/appsetting.constant';
import StorageType from '../session/storage.enum';
import CommonService from './common.service';
import axios from 'axios'

const NoteTemplateService = {
  loggedInUserData: {},

  getLoggedInData() {
    return JSON.parse(StorageService.get(StorageType.session, 'userDetails'));
  },

  findNoteTemplate(reqObj) {
    let url = '';
    url = AppSetting.noteTemplate.find
      .replace('{parentId}', this.getLoggedInData()['parentId']) +
      CommonService.buildQuery(reqObj);

    return axios.get(url)
      .then(res => { return res })
      .catch(err => { return err })
  },

  getNoteTemplateById(reqObj) {
    let url = '';
    url = AppSetting.noteTemplate.getById
      .replace('{parentId}', this.getLoggedInData()['parentId'])
      .replace('{noteTemplateId}', reqObj.notesTemplateId);

    return axios.get(url)
      .then(res => { return res })
      .catch(err => { return err })
  },

  addNoteTemplate(reqObj) {
    let url = '';
    url = AppSetting.noteTemplate.add
      .replace('{parentId}', this.getLoggedInData()['parentId']);

    return axios.post(url, reqObj)
      .then(res => { console.log(res); return res })
      .catch(err => { console.log(err); return err })
  },

  editNoteTemplate(reqObj) {
    let url = '';
    url = AppSetting.noteTemplate.edit
      .replace('{parentId}', this.getLoggedInData()['parentId'])
      .replace('{noteTemplateId}', reqObj.notesTemplateId);

    return axios.put(url, reqObj)
      .then(res => { return res })
      .catch(err => { return err })
  },

  deleteNoteTemplate(id) {
    let url = '';
    url = AppSetting.noteTemplate.delete
      .replace('{parentId}', this.getLoggedInData()['parentId'])
      .replace('{noteTemplateId}', id);

    return axios.delete(url)
      .then(res => { return res })
      .catch(err => { return err })
  },
}

export default NoteTemplateService
